/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum SelectModeEnum {
    "single" = "single",
    "multi" = "multi"
}

export type SelectMode = SelectModeEnum;